@if ($rows().length === 0) {
  <p class="exceptions-empty">{{ $emptyText() }}</p>
} @else {
  @for (row of $rows(); track row.id) {
    <div class="exceptions-row" [class.inherited]="!!row.origin" [attr.data-row-id]="row.id">
      <span class="exceptions-badge" [class.skip]="row.kind === 'skip'" [class.add]="row.kind === 'add'">{{ row.kind === 'skip' ? 'SKIP' : 'ADD' }}</span>
      <span class="exceptions-date">{{ describe(row) }}</span>
      @if (row.reason) {
        <span class="exceptions-reason">· {{ row.reason }}</span>
      }
      @if (row.origin) {
        <span class="exceptions-lock"><i class="fa-solid fa-lock" aria-hidden="true"></i></span>
        <span class="exceptions-chip">{{ originLabel(row) }}</span>
      } @else if (row.removable) {
        <button class="exceptions-remove" type="button" [attr.aria-label]="'Remove ' + describe(row)" (click)="onRemove(row)">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
      }
    </div>
  }
}
